
const MAX_MOBILE_WIDTH = 768;

class DetectMobileHelper {
  public static isMobile(): boolean {
    return window.matchMedia(`(max-width: ${MAX_MOBILE_WIDTH}px)`).matches;
  }
}

export default DetectMobileHelper;
